// src/ReviewCard.js
import React, { useState, useRef } from 'react';

// A helper component with unique class names
const StarRating = ({ rating }) => {
  if (!rating) return null;
  const stars = [];
  for (let i = 0; i < 5; i++) {
    const starClasses = `story-wall-rating__star ${i < rating ? 'story-wall-rating__star--filled' : ''}`;
    stars.push(<span key={i} className={starClasses}>★</span>);
  }
  return <div className="story-wall-rating">{stars}</div>;
};


function ReviewCard({ review }) {
  const { name, title, text, imageUrl, rating, type, isLogo, isLink, videoUrl } = review;
  const [isPlaying, setIsPlaying] = useState(false);
  const videoRef = useRef(null);
  
  // Build the class list with unique names
  const cardClasses = [
    'story-wall-card',
    type ? `story-wall-card--${type}` : 'story-wall-card--text'
  ].join(' ');

  const handlePlayToggle = () => {
    if (videoRef.current) {
      isPlaying ? videoRef.current.pause() : videoRef.current.play();
      setIsPlaying(!isPlaying);
    }
  };

  const handleVideoEnd = () => {
    setIsPlaying(false);
  };

  return (
    <>
    
    <div className={cardClasses} id={`story-wall-review-${review.id}`}>
      
      {type?.startsWith('video') ? (
        <div className="story-wall-card__video-wrapper">
          <video
            ref={videoRef}
            src={videoUrl}
            poster={imageUrl}
            className="story-wall-card__video-element"
            onEnded={handleVideoEnd}
            controls={isPlaying}
            playsInline
          />
          {!isPlaying && (
            <>
              <div className="story-wall-card__video-overlay"></div>
              <div className="story-wall-card__play-button" onClick={handlePlayToggle}>►</div>
            </>
          )}
        </div>
      ) : (
        <div className="story-wall-card__header">
          {imageUrl && (
            <img
              src={imageUrl}
              alt={name}
              className={`story-wall-card__avatar ${isLogo ? 'story-wall-card__avatar--logo' : ''}`}
            />
          )}
          <div className="story-wall-card__author-info">
            <p className="story-wall-card__author-name">{name}</p>
            <p className="story-wall-card__author-title">{title}</p>
          </div>
        </div>
      )}

      {!type?.startsWith('video') && (
        <div className="story-wall-card__content">
          <StarRating rating={rating} />
          {isLink ? (
            <p className="story-wall-card__text">
              Check out the video...{' '}
              <a href="https://storyprompt.com" target="_blank" rel="noopener noreferrer">
                https://storyprompt.com/...
              </a>
            </p>
          ) : (
            <p className="story-wall-card__text">{text}</p>
          )}
        </div>
      )}

      {type?.startsWith('video') && (
        <div className="story-wall-card__footer">
          <div className="story-wall-card__author-info--video">
            <p className="story-wall-card__author-name">{name}</p>
            <p className="story-wall-card__author-title">{title}</p>
          </div>
          {type === 'video-testimonial' && (
            <div className="story-wall-card__content">
              <StarRating rating={rating} />
              <p className="story-wall-card__text">{text}</p>
            </div>
          )}
        </div>
      )}
    </div>
    </>
  );
}

export default ReviewCard;